import { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useOrientation } from 'react-use'
import classNames from 'classnames'
import SwiperCore, { Navigation, Pagination, A11y } from 'swiper'
import { useJsonApi } from 'shared'

SwiperCore.use([Navigation, Pagination, A11y])

const Teaser = ({ blog, horizontal }) => {
  let teaserClass = classNames('generic-news-post-teaser has-small-image', { 'is-horizontal': horizontal })

  return <a href={blog.href} className={teaserClass}>
    <div className='news-post-teaser-image' style={{ backgroundImage: "url(" + blog.image + ")" }}></div>
    <div className='news-post-teaser-content'>
      <h2 className='text-lg'>{blog.title}</h2>
      <div className='news-post-teaser-preview' dangerouslySetInnerHTML={{ __html: blog.body }}></div>
      <div className='news-post-teaser-author'>
        <i className='fas fa-user fa-fw' />
        {blog.author}
        <i className='fas fa-clock fa-fw' />
        {blog.published_at}
      </div>
    </div>
  </a>
}

export const BlogTeaserList = ({ url }) => {
  const [width, setWidth] = useState(window.innerWidth)
  const orientation = useOrientation()
  useEffect(() => setWidth(window.innerWidth), [orientation])
  const { data: blogList } = useJsonApi(url)
  if (!blogList) return null

  let isMobile = width <= 450

  const slides = blogList.map((blog, index) =>
    <SwiperSlide key={index} className={isMobile ? 'swiper-slide' : 'column flex-column'}>
      <Teaser blog={blog} horizontal={!isMobile && index == 0} />
    </SwiperSlide>
  )

  if (isMobile) {
    return <div className='generic-teaser-swiper user-select-none'>
      <Swiper
        slidesPerView={1}
        loop
        pagination={blogList.length > 1 ? { clickable: true } : false}
        roundLengths
      >
        {slides}
      </Swiper>
    </div>
  } else {
    return slides
  }
}
